<div class="formfield">
  <nes-text class="nes-mb-2" weight="bold" color="blue" size="md">
    {{ "USER_DATA.INPUT.USE_PRODUCT.LABEL" | translate }}
  </nes-text>
  <nes-text>
    {{ "USER_DATA.INPUT.USE_PRODUCT.SUB_TEXT" | translate }}
  </nes-text>

  <div class="">
    <ul [cypress]="'use_product'" class="list formfield__inputGroup">
      <li
        *ngFor="let input of useProduct"
        class="list__item formfield__inputGroupItem"
      >
        <div class="radioButton">
          <input
            [(ngModel)]="selectedProductUsage"
            (ngModelChange)="selected.emit($event)"
            [id]="input.value"
            [value]="input.value"
            type="radio"
            class="radioButton__input"
            name="radioGroupUseProduct"
          />
          <label
            class="radioButton__label nes-flex nes-items-center"
            [for]="input.value"
          >
            {{ input.displayText | translate }}
            <span
              *ngIf="input.displayTextOptional as optionalText"
              class="formfield__required nes-ml-1"
            >
              {{ optionalText | translate }}
            </span>
          </label>
        </div>
      </li>
      <ng-container *ngIf="selectedProductUsage === ProductStart.DATE">
        <section>
          <nes-datepicker-input
            label=""
            modal-top="hi there"
            [value]="formattedDate"
            required
            nes-id="datepicker"
            (nesOnChange)="dateSelected.emit($event.detail.date)"
            [minDate]="minimalUseDate | dateFormat: 'YYYY-MM-DD'"
            [maxDate]="maximalUseDate | dateFormat: 'YYYY-MM-DD'"
          ></nes-datepicker-input>
        </section>
      </ng-container>
    </ul>
  </div>
</div>
